import React, { useState, useEffect } from 'react';
import { useApi } from '../../../hooks/useApi';
import logger from "../../../utils/logger";
import { fmtDateTime } from '../../../utils/ruDates';
function AdminOwnershipTransfers() {
  const {
    request
  } = useApi();
  const [transfers, setTransfers] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    loadTransfers();
  }, []);
  const loadTransfers = async () => {
    setLoading(true);
    try {
      const data = await request('/api/v1/admin/ownership-transfers');
      setTransfers(data || []);
    } catch (error) {
      logger.error('Failed to load transfers', error);
    } finally {
      setLoading(false);
    }
  };
  return <div className="admin-page">
            <div style={{
      marginBottom: '30px'
    }}>
                <h1>Передача прав доступа</h1>
                <p style={{
        color: '#666'
      }}>Запросы на передачу владения проектами (Workspace) или кабинетами (Marketplace)</p>
            </div>

            <div style={{
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
      overflow: 'hidden'
    }}>
                <table style={{
        width: '100%',
        borderCollapse: 'collapse'
      }}>
                    <thead style={{
          background: '#f8f9fa',
          borderBottom: '2px solid #eee'
        }}>
                        <tr>
                            <th style={{
              padding: '15px',
              textAlign: 'left'
            }}>Тип / ID ресурса</th>
                            <th style={{
              padding: '15px',
              textAlign: 'left'
            }}>От кого</th>
                            <th style={{
              padding: '15px',
              textAlign: 'left'
            }}>Кому</th>
                            <th style={{
              padding: '15px',
              textAlign: 'center'
            }}>Статус</th>
                            <th style={{
              padding: '15px',
              textAlign: 'right'
            }}>Дата</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && <tr><td colSpan="5" style={{
              padding: '40px',
              textAlign: 'center'
            }}>Загрузка...</td></tr>}
                        {!loading && transfers.length === 0 && <tr><td colSpan="5" style={{
              padding: '40px',
              textAlign: 'center'
            }}>Запросов не найдено</td></tr>}
                        {transfers.map(t => <tr key={t.id} style={{
            borderBottom: '1px solid #f5f5f5'
          }}>
                                <td style={{
              padding: '15px'
            }}>
                                    <div style={{
                fontWeight: '500',
                textTransform: 'capitalize'
              }}>{t.scope_type}</div>
                                    <div style={{
                fontSize: '12px',
                color: '#999'
              }}>{t.scope_id}</div>
                                </td>
                                <td style={{
              padding: '15px'
            }}>{t.from_user_email}</td>
                                <td style={{
              padding: '15px'
            }}>{t.to_user_email}</td>
                                <td style={{
              padding: '15px',
              textAlign: 'center'
            }}>
                                    <span style={{
                padding: '3px 8px',
                borderRadius: '4px',
                fontSize: '12px',
                background: t.status === 'pending' ? '#fef9c3' : t.status === 'accepted' ? '#dcfce7' : '#fee2e2',
                color: t.status === 'pending' ? '#854d0e' : t.status === 'accepted' ? '#166534' : '#991b1b'
              }}>
                                        {t.status.toUpperCase()}
                                    </span>
                                </td>
                                <td style={{
              padding: '15px',
              textAlign: 'right',
              color: '#666'
            }}>
                                    {fmtDateTime(t.created_at)}
                                </td>
                            </tr>)}
                    </tbody>
                </table>
            </div>
        </div>;
}
export default AdminOwnershipTransfers;
